import { render, staticRenderFns } from "./EvaluationRatingsForCurrentAndPreviousPeriod.vue?vue&type=template&id=6d6a408b&"
import script from "./EvaluationRatingsForCurrentAndPreviousPeriod.vue?vue&type=script&lang=js&"
export * from "./EvaluationRatingsForCurrentAndPreviousPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports